module.exports = __webpack_public_path__ + "static/media/nodejs.f7337d33.png";